export default function UseApiV1(urlPart: string) {
    return `/api/v1/${urlPart}`;
}